import { Autocomplete, Box, Checkbox, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CheckIcon from '@mui/icons-material/Check';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { Color, FontStyle, defaultBottomPadding, defaultInnerStyle, defaultContainerStyle } from '../../constants';
import CheckButton from '../CheckButton';
import HeartButton from '../HeartButton'
import TempDisplay from '../TempDisplay';
import { CustomPaper, StyledTextField } from '../AutocompleteUtils';


const styles = {
  container: {
    ...defaultContainerStyle
  },
  inner: {
    ...defaultInnerStyle,
    cursor: 'pointer',
  },
  title: {
    ...FontStyle.body,
    textAlign: 'center',
    fontSize: '1rem',
    lineHeight: 1.3,
    paddingBottom: '4px',
  },
  link: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'center',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'black',
  },
  body: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'left',
    lineHeight: '1.4',
    maxWidth: '500px',
    '& > * >a': {
      color: '#000',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      }
    }
  },
  label: {
    ...FontStyle.headingBody,
    fontSize: '1rem',
    // textAlign: 'center',
    lineHeight: '1.4',
    width: '100%',
    maxWidth: '500px',
  },
  search: {
    width: '100%',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: '4px',
    border: '1px solid rgb(204, 204, 204)',
  },
  searchProps: {
    disableUnderline: true,
  },
  info: {
    borderLeft: `6px solid ${Color.primary}`,
    borderRadius: '0.75rem',
    backgroundColor: '#fff',
    padding: '1.2rem',
  }
}

const selectionData = [
  {
    title: 'Daily',
    bullets: ['Apply to jobs soon after they are advertized. We typically see the most applications in the first 3 days', 'Our most active users are emailed daily'],
  },
  {
    title: 'Weekly',
    bullets: ['Get in the rhythm of checking the best new jobs every week']
  },
  {
    title: 'Never',
    bullets: ["I don't want to receive any emails about the latest jobs"]
  }
]


const Q17_Referral = ({ selected, setSelected, setQuestionsDone, questionNum, options }) => {
  useEffect(() => {
    setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
  }, [selected])
  return (
    <Stack direction='column' sx={styles.container} alignItems='center' spacing={2}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack direction='column' sx={{ ...styles.inner }}
        spacing={1}
      >
        <Box sx={styles.title}>We value your feedback to better serve job seekers like yourself.</Box>
        {options.map((option, i) => {
          return (
            <CheckButton key={i} text={option} selected={selected[questionNum].includes(i)} setSelected={() => {
              if (selected[questionNum].includes(i)) {
                setSelected(s => { return { ...s, [questionNum]: s[questionNum].filter((item) => item !== i) } })
              } else {
                setSelected(s => { return { ...s, [questionNum]: [...s[questionNum], i] } })
              }
            }}
            />
          )
        })}
      </Stack>
    </Stack>
  )
}

export default Q17_Referral